interface ObjectWithPosition {
  position: number;
}
export function sortByPosition(a: ObjectWithPosition, b: ObjectWithPosition): number {
  if (a.position < b.position) return -1;
  if (a.position > b.position) return 1;
  return 0;
}
